// Multipage form render / show form and initial back button
import { PageUtils } from "./helpers/page-utils";

window.addEventListener('load', event => {
    const splitMultiPageFormPanels = document.querySelectorAll('.multi-page-form-panel.split-multi-page-form-panel')

    if (splitMultiPageFormPanels.length) {
        document.addEventListener('click', (event) => {
            const target = event.target;

            // Handle showing of forms in multipage form panels
            if (target.matches('[data-toggle-form-index]') || target.parentElement?.matches('[data-toggle-form-index]')) {
                const showFormContainer = target.closest('[data-show-form-index]');
                const toggleFormIndex = target.dataset.toggleFormIndex;

                if (showFormContainer && toggleFormIndex) {
                    showFormContainer.dataset.showFormIndex = toggleFormIndex;
                }
            }

            // Handle plus minus on number fields with large buttons
            if (target.matches('[data-action]')) {
                const buttonValue = target.dataset.action === 'minus' ? -1 : 1;
                const buttonParentRow = target.closest('.freeform-row');

                if (buttonParentRow) {
                    const inputToAdjust = buttonParentRow.querySelector('input[type="number"]');

                    if (inputToAdjust) {
                        const currentValue = parseInt(inputToAdjust.value, 10) || 0;
                        if (buttonValue === -1 && currentValue > 0) {
                            inputToAdjust.value = currentValue + buttonValue;
                        } else if (buttonValue === 1) {
                            inputToAdjust.value = currentValue + buttonValue;
                        }
                    }
                }
            }

            // Start - functions for instructions modals
            // Function to close the modal and remove the keydown event listener
            function closeModal(modal) {
                document.body.removeChild(modal);
                PageUtils.bodyLockToggleOff();
                document.removeEventListener('keydown', handleEscape);
            }

            // Function to handle the Escape key event
            function handleEscape(event) {
                if (event.key === 'Escape') {
                    const modal = document.querySelector('.multipage-form-modal');
                    if (modal) {
                        closeModal(modal);
                    }
                }
            }

            // on click of instructions button
            if (target.matches('div[data-instructions]')) {
                // Remove existing modals if any
                const existingMultipageFormModals = document.querySelectorAll('.multipage-form-modal');
                if (existingMultipageFormModals.length) {
                    existingMultipageFormModals.forEach(modal => modal.remove());
                }

                // Create new modal with contents of instruction field
                const content = target.innerHTML;
                const modal = document.createElement('div');
                modal.classList.add('multipage-form-modal');
                modal.innerHTML =
                    `
                        <div class="modal-content relative">
                            <div class="modal-close">
                                <svg class="modal-decoration" viewBox="0 0 46 86" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M46 0.5L0 85.5H46V0.5Z" fill="inherit"></path>
                                </svg>
                                <svg class="modal-cross" width="19" height="20" viewBox="0 0 19 20" fill="#000" xmlns="http://www.w3.org/2000/svg"><path d="M18.385 1.414a2 2 0 0 0-2.828 0L9.813 7.157 4.241 1.585a2 2 0 1 0-2.828 2.829l5.572 5.572-5.57 5.57a2.001 2.001 0 0 0 2.828 2.829l5.57-5.571 5.743 5.742a2 2 0 1 0 2.828-2.829l-5.742-5.741 5.743-5.743a2 2 0 0 0 0-2.829Z" fill="inherit"/>
                                </svg>
                            </div>
                            ${content}
                        </div>
                    `;
                document.body.appendChild(modal);
                PageUtils.bodyLockToggleOn();

                // Add event listener for the Escape key
                document.addEventListener('keydown', handleEscape);

                // Close modal on clicking close button
                modal.querySelector('.modal-close').addEventListener('click', function () {
                    closeModal(modal);
                });

                // Close modal on clicking outside the content
                modal.addEventListener('click', function (e) {
                    if (e.target === modal) {
                        closeModal(modal);
                    }
                });
            }
        });
    }
});

// Form functions / multipage proceed on radio click & input updates
window.addEventListener('load', event => {
    const multipageFreeforms = document.querySelectorAll('form.multipage-freeform-form');

    for (const multipageFreeform of multipageFreeforms) {
        // proceed on form value change if updated value is a 'proceed on click' element
        multipageFreeform.addEventListener('change', (event) => {
            proceedOnClick(event.target, multipageFreeform);
            checkConditionalRequirements(multipageFreeform);
        });

        multipageFreeform.addEventListener('click', (event) => {
            const clickedElement = event.target;

            // Check if the clicked button is either "submit" or "back"
            const buttonAction = clickedElement.getAttribute('data-freeform-action');

            if (buttonAction === 'submit' || buttonAction === 'back') {
                // If the clicked button is "submit", execute the function to check inputs
                if (buttonAction === 'submit') {
                    checkConditionalRequirements(multipageFreeform);
                }
                // If the clicked button is "back", remove the required attribute from all inputs
                else if (buttonAction === 'back') {
                    const allInputs = multipageFreeform.querySelectorAll('input');
                    allInputs.forEach(input => {
                        input.removeAttribute('required');
                    });
                }
            }

            proceedOnClick(event.target, multipageFreeform);
        });
    }
});

function proceedOnClick(comparedElement, form) {
    if (comparedElement.tagName === 'INPUT' && comparedElement.getAttribute('type') === 'radio') {
        const dataProceedOnClick = comparedElement.getAttribute('data-proceed-on-click');
        const inputValue = comparedElement.value;

        if (dataProceedOnClick === 'true' || (dataProceedOnClick && dataProceedOnClick.split(',').includes(inputValue))) {
            const submitButton = form.querySelector('[data-freeform-action="submit"]');
            if (submitButton) {
                submitButton.click();
            }
        }
    }
}

function checkConditionalRequirements(form) {
    const inputsWithConditionalRequirement = form.querySelectorAll('input[data-conditional-requirement="true"]');
    inputsWithConditionalRequirement.forEach(input => {
        const closestFreeformColumn = input.closest('.freeform-column');
        if (closestFreeformColumn) {
            const inlineStyle = closestFreeformColumn.getAttribute('style');
            const required = inlineStyle && inlineStyle.includes('display: none;');
            if (required) {
                input.removeAttribute('required');
            } else {
                input.setAttribute('required', 'true');
            }
        }
    });
}
